import styled from 'styled-components';

import { Paper } from '@components/Paper';

export const ContainerStyles = styled(Paper)`
  margin: 24px;
  padding: 0 24px 0 24px;
`;
